import jsPDFCashTemplate, { OutputType } from "./CashTemplate";
import currency from 'currency.js'

// Date Fns is used to format the dates we receive
// from our API call
import { parseISO, format } from 'date-fns';
import logo from '../../assets/img/logo.jpg'; // Tell webpack this JS file uses this image


// define a generatePDF function that accepts a cashs argument
const CashPrintPDF = (cash, configData, inData, outData) => {
    const myDate = format(new Date(), 'dd/MM/yyyy')
    const currFormat = { decimal: ',', symbol: '', separator: '.' }

    // console.log("indata: ", inData, typeof inData)
    // console.log("outdata: ", outData, typeof outData)

    var totalEnt = 0;
    var totalSal = 0;
    cash.cash_detail.forEach(function (record) {
        if (record.amount > 0) totalEnt += record.amount;
        if (record.amount < 0) totalSal += record.amount;
    });


    var openingAmount = currency(cash.amount_open, currFormat).format()
    var closingAmount = currency((cash.amount_open + totalEnt + totalSal), currFormat).format()

    totalEnt = currency(totalEnt, currFormat).format()
    totalSal = currency(totalSal, currFormat).format()

    var arrLines = Array.from(cash.cash_detail, (item, index) => ([
        index + 1,
        item.concept,
        currency(item.amount, currFormat).format()
    ]))


    arrLines = [...arrLines,
    [{ content: "", styles: { fillColor: [220, 220, 220], textColor: [0, 0, 0] } },
    {
        content: `Monto Apertura:`, styles: { fillColor: [220, 220, 220], textColor: [0, 0, 0] }
    },
    {
        content: openingAmount, styles: { fillColor: [220, 220, 220], textColor: [0, 0, 0] }
    },
    ],
    [{ content: "", styles: { fillColor: [220, 220, 220], textColor: [0, 0, 0] } },
    {
        content: `Total Entradas:`, styles: { fillColor: [220, 220, 220], textColor: [0, 0, 0] }
    },
    {
        content: totalEnt, styles: { fillColor: [220, 220, 220], textColor: [0, 0, 0] }
    }
    ],
    [{ content: "", styles: { fillColor: [220, 220, 220], textColor: [0, 0, 0] } },
    {
        content: `Total Salidas:`, styles: { fillColor: [220, 220, 220], textColor: [0, 0, 0] }
    },
    {
        content: totalSal, styles: { fillColor: [220, 220, 220], textColor: [0, 0, 0] }
    },
    ],
    [{ content: "", styles: { fillColor: [220, 220, 220], textColor: [0, 0, 0] } },
    {
        content: `Cierre Caja:`, styles: { fillColor: [220, 220, 220], textColor: [0, 0, 0] }
    },
    {
        content: closingAmount, styles: { fillColor: [220, 220, 220], textColor: [0, 0, 0] }
    },
    ],
    [{
        content: `Descripcion:`, styles: { fillColor: [220, 220, 220], textColor: [0, 0, 0] }
    },
    {
        content: cash.description, colSpan: 3, styles: { fillColor: [220, 220, 220], textColor: [0, 0, 0] }
    },
    ]
    ]

    var myIndex = 0;
    var arrInTypeLines = Array.from(inData, (item, index) => ([
        index + 1,
        item.forma_pago,
        currency(item.total, currFormat).format(),
        outData.length == 0 ? '0.00' : outData.find(element => element.forma_pago === item.forma_pago)
            ? currency(outData.find(element => element.forma_pago === item.forma_pago).total, currFormat).format() : '0.00'
    ]))

    myIndex = myIndex + arrInTypeLines.length;
    var arrOutTypeLines = Array.from(outData, (item, index) => ([
        inData.find((element) => element.forma_pago === item.forma_pago) ? 9999 :
            index + 1,
        item.forma_pago,
        currency(0.00, currFormat).format(),
        currency(outData.find((element) => element.forma_pago === item.forma_pago).total, currFormat).format()
    ]))


    var arrTypeLines = [...arrInTypeLines, ...arrOutTypeLines]

    arrTypeLines = arrTypeLines.filter(item => item[0] !== 9999);

    // console.log(arrTypeLines)

    var typeHeader = ["#", "Forma de pago", "Entradas", "Salidas"]


    var props = {
        outputType: 'blob',
        returnJsPDFDocObject: true,
        fileName: `Cash-${cash.cash}-${new Date()}`,
        orientationLandscape: false,
        typeHeader: typeHeader,
        typeLines: arrTypeLines,
        logo: {
            src: logo,
            width: 30.33, //aspect ratio = width/height
            height: 26.66,
            margin: {
                top: 0, //negative or positive num, from the current position
                left: 0 //negative or positive num, from the current position
            }
        },
        business: {
            name: configData.company_name,
            address: `${configData.company_address1} - ${configData.company_address2} `,
            phone: configData.company_phone,
            email: configData.company_email,
            email_1: configData.company_email1,
            website: configData.company_web_url,
            date: myDate
        },
        invoice: {
            label: `Reporte de Caja al: ${format(parseISO(cash.date), 'dd/MM/yyyy')} `,
            headerBorder: true,
            tableBodyBorder: true,
            header: ["#", "Concepto", "Monto"],
            table: arrLines,
            invTotalLabel: "",
            invTotal: 0,
            invCurrency: "",
            row1: {
                // col1: `Monto Apertura`,
                // col2: cash.amount_open.toFixed(2),
                // col3: '$',
                // style: {
                //     fontSize: 10 //optional, default 12
                // }
            },
            row2: {
                // col1: `Total Salidas`,
                // col2: totalSal.toFixed(2),
                // col3: '$',
                // style: {
                //     fontSize: 10 //optional, default 12
                // }
            },
            row3: {
                // col1: 'Total Entradas:',
                // col2: totalEnt.toFixed(2),
                // col3: '$',
                // style: {
                //     fontSize: 10 //optional, default 12
                // }
            },
            invDescLabel: "",
            invDesc: "",
        },
        footer: {
            text: "",
        },
        pageEnable: true,
        pageLabel: "Page ",
    };
    const pdfCreated = jsPDFCashTemplate(props); //returns number of pages created
    var blob = pdfCreated.blob;

    var pdfObject = pdfCreated.jsPDFDocObject;

    window.open(URL.createObjectURL(pdfObject.output("blob")))

    // pdfCreated.jsPDFDocObject.output("blob"); //or .output('<outputTypeHere>');

};

export default CashPrintPDF;